import React, { useState, useEffect } from 'react';
import './SendRecoveryEmailForm.css';
import Button from '../Button';
import { AthenaCore } from 'athena-core';

import { useWindowSize } from '../../hooks/useWindowSize';
import { Link } from 'react-router-dom';
import Unit from '../Modular/Unit';
import { useSendVerificationEmail } from '../../hooks/useSendEmail';

const SendRecoveryEmailForm = () => {
  const [email, setEmail] = useState('');
  const { sendPasswordRecoveryEmail, sent } = useSendVerificationEmail();

  const emailIsValid = (): boolean => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const sendEmailHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!emailIsValid()) {
      AthenaCore.openModal({
        title: 'Error',
        message: 'please provide valid email address',
        type: 'error',
      });
      return;
    }
    sendPasswordRecoveryEmail(email);
  };

  return (
    <form className="recovery-form" onSubmit={sendEmailHandler}>
      <Unit layout="flex">
        <input
          className="input-box"
          type="text"
          onChange={(e) => setEmail(e.target.value)}
        ></input>
        <Button variant="secondary" type="submit">
          Send Recovery Email
        </Button>
      </Unit>
    </form>
  );
};

export default SendRecoveryEmailForm;
